import Midday from '@/Assets/images/phases/Midday.png';
import MiddayBg from '../assets/MiddayBg.png';
import Midnight from '@/Assets/images/phases/Midnight.png';
import MidnightBg from '../assets/MidnightBg.png';
import Sunrise from '@/Assets/images/phases/Sunrise.png';
import SunriseBg from '../assets/SunriseBg.png';
import Sunset from '@/Assets/images/phases/Sunset.png';
import SunsetBg from '../assets/SunsetBg.png';

interface MainPhase {
  name: string;
  description: string;
  list: string[];
  startDate: string;

  nftThumbnail: string;

  background?: string;
}

export const mainPhasesData: MainPhase[] = [
  {
    name: 'Sunrise Phase',
    description:
      'Sunrise Phase dedicated to core functionalities, expanding on Ethereum and L1 and L2 EVM networks',
    list: [
      'EVM Networks Expansion',
      'Advanced Bridging Mode',
      'Testnet Bridge',
      'Multichain Faucet',
    ],
    startDate: 'Start of 2024',

    nftThumbnail: Sunrise,

    background: SunriseBg,
  },
  {
    name: 'Midday Phase',
    description:
      'Midday Phase introduces Cross Chain Swap, enabling seamless swapping of native tokens and stablecoins across different networks.',
    list: [
      'Stablecoin Cross Chain Swaps',
      'Native Cross Chain Swaps',
      'Dapp Explorer',
      'Retro Score',
    ],
    startDate: 'Mid 2024',

    nftThumbnail: Midday,

    background: MiddayBg,
  },
  {
    name: 'Sunset Phase',
    description:
      'Sunset Phase expands to Non-EVM networks, enhancing user multichain experience',
    list: [
      'Non-EVM Networks Expansion',
      'Non-EVM Cross Chain Swaps',
      'RetroGPT Beta Launch',
    ],
    startDate: 'Late 2024',

    nftThumbnail: Sunset,

    background: SunsetBg,
  },
  {
    name: 'Midnight Phase',
    description:
      'Midnight Phase marks RetroBridge shift to decentralization, entering a realm of total autonomy',
    list: [
      'Cross Chain Messaging',
      'Decentralized ZK-Proof Validation',
      'Decentralized Governance',
    ],
    startDate: 'Start of 2025',

    nftThumbnail: Midnight,
    background: MidnightBg,
  },
];
